/* tk-revele.js — l'apparition au scroll. UN mouvement, une fois.

   Mesuré le 22/09 : 0 keyframes chez nous, 60 à 81 chez les quatre références.
   Mais l'audit §2 dit aussi que ce qui fait « cher » chez Holy, c'est UNE
   courbe et UNE durée partout — pas un catalogue d'effets. Donc ici : les
   sections montent de 14 px en s'opacifiant, 0,55 s, et on ne les observe plus.

   La classe `js` est posée AVANT tout : c'est elle qui autorise le CSS à
   masquer. Sans JavaScript, rien n'est masqué — une animation qui échoue ne
   doit jamais coûter le contenu.                                            */
(function () {
  var r = document.documentElement;
  r.classList.add('js');

  function demarre() {
    // Le hero est au-dessus du pli : il doit être là à la première image.
    var cibles = document.querySelectorAll(
      'main > .shopify-section > section:not(.tk-hero), main > section:not(.tk-hero)');
    if (!cibles.length) cibles = document.querySelectorAll('section:not(.tk-hero)');

    if (!('IntersectionObserver' in window) ||
        matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var o = new IntersectionObserver(function (entrees) {
      entrees.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('est-vu');
        o.unobserve(e.target);              // une fois, pas à chaque passage
      });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.04 });

    cibles.forEach(function (s) {
      if (s.getBoundingClientRect().top < innerHeight) return;  // déjà visible
      // PIÈGE : un `transform` sur un ancêtre change le bloc conteneur de ses
      // descendants `position:fixed` — ils cessent d'être fixés à l'écran.
      // La barre d'achat collante vit dans la section configurateur : animée,
      // elle disparaissait. Une section qui contient du `fixed` n'est jamais
      // révélée. Détecté le 22/09 : la barre ne s'affichait plus du tout.
      if (s.querySelector('.tk-barre, [style*="position:fixed"]')) return;
      var fixe = false, n = s.querySelectorAll('*');
      for (var i = 0; i < n.length && !fixe; i++)
        if (getComputedStyle(n[i]).position === 'fixed') fixe = true;
      if (fixe) return;
      s.setAttribute('data-tk-revele', '');
      o.observe(s);
    });
  }
  if (document.readyState === 'loading')
    document.addEventListener('DOMContentLoaded', demarre);
  else demarre();
})();
